class PriceHelper {
  constructor(parent) {
    if (parent == null) {
      this.parent = $('body');
    } else {
      this.parent = parent;
    }
    this.price = this.getContent('price');
    this.comparePrice = this.getContent('compare_at_price'); // use only for list page
    this.wasPrice = function () {
      let target = this.parent.find('.current_price').parent().parent().find('.was_price')[0];
      if (target == null) {
        return target;
      }
      return PriceHelper.convertStringPriceToInt(target.innerText.replace(PriceHelper.getCurrency(), ''));
    }
    this.priceMin = this.getContent('price_min');
    this.premiumSaleNum = 90;
  }

  static getCurrency() {
    return $('body').attr('data-money-format').replace('{{amount}}', '');
  }

  static updatePriceInfoWithList() {
    $('[itemprop=itemListElement]').each(function (index) {
      let helper = new PriceHelper($(this));
      helper.updatePriceInfo(true);
    });
  }

  static updatePriceInfoWithModal() {
    let helper = new PriceHelper($('.fancybox-outer'));
    helper.updatePriceInfo();
  }

  static updatePriceInfoWithDetail() {
    let helper = new PriceHelper();
    helper.updatePriceInfo();
  }

  static convertStringPriceToInt(price) {
    return price.replace(/,/g, '');
  }

  static convertIntToStringWithComma(price) {
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  static getFloorPrice(price) {
    // COM-183 script editor 의 로직과 맞추어 소수점 내림
    return Math.floor(price*100)/100;
  }

  getCurrentPrice() {
    let searchPropString = '.current_price';
    let target = this.parent.find(searchPropString);
    if (target == null || target.length==0) {
      return null;
    }
    return PriceHelper.convertStringPriceToInt($(target[0]).text().replace(PriceHelper.getCurrency(), ''));
  }

  getContent(prop) {
    let searchPropString = '[itemprop=' + prop + ']';
    let targetAttr = 'content';
    let target = this.parent.find(searchPropString);
    if (target == null) {
      return target;
    }
    return target.attr(targetAttr);
  }

  getPremiumPrice(isForList) {
    let salePrice = this.getOriginPrice(isForList);
    if (salePrice == null) {
      salePrice = this.priceMin;
    }

    if (isForList && this.comparePrice) // for list page
    {
      let discountNum = PriceHelper.getPriceOff(this.comparePrice, salePrice);
      return PriceHelper.getFloorPrice(this.comparePrice * ((this.premiumSaleNum-discountNum)/100));
    }

    if (this.wasPrice()) { // for detail page, when product have multiple variant options
      let discountNum = PriceHelper.getPriceOff(this.wasPrice(), salePrice);
      return PriceHelper.getFloorPrice(this.wasPrice() * ((this.premiumSaleNum-discountNum)/100));
    }

    if (salePrice) {
      return PriceHelper.getFloorPrice(salePrice * (this.premiumSaleNum/100));
    }
  }

  getOriginPrice(isForList) {
    // current price : variable for detail page
    // price : variable for list page
    if (isForList) {
      return this.price;
    } else if (this.getCurrentPrice()) {
      return this.getCurrentPrice();
    } else {
      return this.wasPrice();
    }
  }

  static getPriceOff(originPrice, salePrice) {
    // COM-183 script editor 의 로직과 맞추어 소수점 내림
    return Math.floor((originPrice - salePrice).toFixed(2) / originPrice * 100);
  }

  getOriginPriceOff(isForList) {
    return PriceHelper.getPriceOff(this.wasPrice(), this.getOriginPrice(isForList));
  }

  getPremiumPriceOff(isForList) {
    if (this.wasPrice()) {
      return PriceHelper.getPriceOff(this.wasPrice(), this.getPremiumPrice()) - this.getOriginPriceOff(isForList);
    }

    return PriceHelper.getPriceOff(this.getOriginPrice(isForList), this.getPremiumPrice());
  }

  static generatePriceToMoneyText(price) {
    return PriceHelper.getCurrency() +
      PriceHelper.convertIntToStringWithComma((Math.floor(price * 100) / 100).toFixed(2));
  }

  updatePriceInfo(isForList = false) {
    let section = this.parent.find('[class="odk_wrap_premium_section"]');
    if (!isForList && !this.getOriginPrice()) {
      section.hide();
      return
    } else {
      section.show();
    }

    let priceOff = this.parent.find('[class="odk_price_off"] > .value');
    if (priceOff) {
      priceOff.text(this.getOriginPriceOff(isForList));
    }

    let premiumPrice = this.parent.find('.odk_premium_price > .money');
    if (premiumPrice) {
      premiumPrice.text(PriceHelper.generatePriceToMoneyText(this.getPremiumPrice(isForList)));
    }

    let premiumPriceOff = this.parent.find('[class="odk_price_off odk_premium"] > .value');
    if (premiumPriceOff) {
      premiumPriceOff.text(this.getPremiumPriceOff(isForList));
    }
  }
}
